import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { scroller, Element } from 'react-scroll';

import {
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Snackbar,
  CircularProgress
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { withStyles } from "@material-ui/core/styles";
import Red from "@material-ui/core/colors/red";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import * as PaymentActions from "../../actions/PaymentActions";
import * as AccountActions from "../../actions/AccountActions";

import { asyncCheck, handleStepTwo } from "../../utils";
import { validateFields } from "../../utils/models";

import { SCROLL_OFFSET } from "../../constants";

const YEARS = [...Array(100)].map((val, i) => ({
  value: new Date().getFullYear() - i,
  label: `${new Date().getFullYear() - i}`,
}));
const MONTHS = [
  { value: 0, label: "Jan" },
  { value: 1, label: "Feb" },
  { value: 2, label: "Mar" },
  { value: 3, label: "Apr" },
  { value: 4, label: "May" },
  { value: 5, label: "Jun" },
  { value: 6, label: "Jul" },
  { value: 7, label: "Aug" },
  { value: 8, label: "Sep" },
  { value: 9, label: "Oct" },
  { value: 10, label: "Nov" },
  { value: 11, label: "Dec" },
];

const styles = (theme) => ({
  radioContainer: {
    backgroundColor: "unset !important"
  },
  nextBtn: {
    margin: "0 0 10px 0",
    height: "3rem"
  },
  cartIcon: {
    color: "white",
  },
  cartHeader: {
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    gridGap: "6px",
    marginTop: "10px",
  },
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": {
      fontSize: "1.2em",
    },
    "& legend": {
      fontSize: "0.78em",
    },
  },
})(TextField);

const SNACKBAR_INIT_VALUE = {
  open: false,
  type: "error",
  message: ""
};

class StepOne extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goingNextStep: false,
      showPass: false,
      snackbar: SNACKBAR_INIT_VALUE,
    };

    this.timeout = 0;
    this.onChange = this.onChange.bind(this);
    this.goToNextStep = this.goToNextStep.bind(this);
    this.toggleShowPass = this.toggleShowPass.bind(this);
    this.getMonthValue = this.getMonthValue.bind(this);
    this.getYearValue = this.getYearValue.bind(this);
    this.getCountryValue = this.getCountryValue.bind(this);
    this.onAutoFill = this.onAutoFill.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    let { goingNextStep } = this.state;
    let { goingNextStep: prevGoingNextStep } = prevState;

    if ((prevGoingNextStep === false && goingNextStep === true)) {
      this.props.actions.nextStep();
    }
  };

  toggleShowPass = () => this.setState({ showPass: !this.state.showPass });

  handleSnackbarClose = () => this.setState({ snackbar: { ...this.state.snackbar, open: false } });

  onChange = (event, field, value) => {
    event.persist();
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if(field === "hasTraded") value = value === "1" ? true : value === "0" ? false : null;
      this.props.accountActions.updateUserAccount(field, value);
    }, 100);
  };

  onAutoFill = (event, field, value, prevValue) => {
    if(prevValue === "") this.props.accountActions.updateUserAccount(field, value);
  }

  onValidateField = (field) => {
    const { userAccount } = this.props;
    const details = userAccount.details || {};

    const values = {};

    if (userAccount[field]) {
      values[field] = userAccount[field];
      if (field === 'passwordConfirm') values['password'] = userAccount['password'];
    } else if (details[field]) values[field] = details[field];
    else if (details.address[field]) values[field] = details.address[field];

    this.onValidateFields([field], values);
  }

  onValidateFields = (fields, values) => {
    const newErrors = validateFields(fields, values, this.props.formErrors);
    this.props.actions.setFormErrors(newErrors);
    return newErrors;
  }

  goToNextStep = async () => {
    const { actions, userAccount, accountActions, openSnackbar, countries } = this.props;
    const details = userAccount.details || {};
    const { email, password, username, broker, hearAboutUs, leadId } = userAccount;
    const { firstName, lastName, number, address, } = details;
    const { country } = address || {};
    const countryObj = countries.find(c => c.value === country) || null;
    const countryName = countryObj ? countryObj.label : '';
    const fields = ["username", "password", "country", "passwordConfirm", "broker", "hearAboutUs"];
    const values = fields.reduce((final, field) => {
      if (userAccount[field] !== undefined) {
        final[field] = userAccount[field];
        if (field === 'passwordConfirm') final['password'] = userAccount['password'];
      } else if (details[field] !== undefined) final[field] = details[field];
      else if (details.address[field] !== undefined) final[field] = details.address[field];

      return final;
    }, {});

    actions.setLoading(true);

    const newErrors = this.onValidateFields(fields, values);

    let errorFields = Object.entries(newErrors).filter(([_, { hasError }]) => hasError);

    if (errorFields.length === 0) {
      try {
        const result = await asyncCheck("username", username);
  
        if (result.exist === false) {
          // username does not exist
          openSnackbar({
            type: "success",
            open: true,
            message: `Hi ${firstName.charAt(0).toUpperCase() + firstName.slice(1)}, Redirecting to payment...`,
            duration: 4000
          });

          const data = { firstName, lastName, username, password, number, email, leadId, country: countryName };
          if (hearAboutUs && hearAboutUs.length > 1) data.hearAboutUs = hearAboutUs;
          if (broker && broker.length > 1) data.broker = broker;

          const { ok, userAccount, ...rest } = await handleStepTwo(data);

          if (ok) {
            accountActions.setUserAccount(userAccount);
            this.setState({ goingNextStep: true });
          } else {
            openSnackbar(null);
            let message = rest.message;

            if (message && message === 'Bad Request') {
              message = 'Connection Lost, Please Refresh';
            }
            openSnackbar({
              type: "error",
              open: true,
              message: message || 'Something went wrong. Please try again',
              duration: 4000
            });
          }
          actions.setLoading(false);
        } else if (result.exist === true) {
          actions.setLoading(false);
          actions.updateFormError({ key: "username", error: "Username already exists. Please use another username." });
          openSnackbar({
            type: "warning",
            message: "Username already exists. Please use another username.",
            open: true,
            duration: 4000
          }, () => this.scrollToElement(`element-username`));
  
        } else throw new Error('Something went wrong. Please try again');
      } catch (error) {
        console.error(error);
        openSnackbar({
          type: "error",
          message: error.message,
          open: true,
          duration: 4000
        });
        actions.setLoading(false);
      }
    } else {
      actions.setLoading(false);
      let elementName = `${errorFields[0][0]}`;
      if(elementName === "country") elementName += `-2`;
      this.scrollToElement(`element-${elementName}`);
    }
  };

  scrollToElement = (elementName) => {
    scroller.scrollTo(elementName, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: SCROLL_OFFSET
    });
  }

  getMonthValue = (val) => {
    let month = MONTHS.find(m => m.label.toLowerCase() === val.toLowerCase().trim());
    return month ? month.value : -1;
  }

  getYearValue = (val) => {
    let year = YEARS.find(y => y.label.toLowerCase() === val.toLowerCase().trim());
    return year ? year.value : -1;
  }

  getCountryValue = (label) => {
    let country = this.props.countries.find(c => c.label.toLowerCase() === label.toLowerCase().trim());
    return country ? country.value : "0";
  }

  render = () => {
    const {
      props,
      state,
      onChange,
      onValidateField,
      toggleShowPass,
      goToNextStep,
      onAutoFill,
      handleSnackbarClose
    } = this;
    const { showPass, snackbar } = state;
    const { formErrors, classes, loading, userAccount, } = props;

    return (
      <Grid container>
        <Grid item xs={12} style={{ paddingBottom: "6px" }}>
          <Typography variant="h4" gutterBottom><strong>Create Your Account</strong></Typography>
        </Grid>
        <Grid item xs={12}>
          <form noValidate>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="stretch"
              spacing={2}
            >
              <Grid item xs={12}>
                <Element name="element-username">
                  <TviTextFiled
                    autoFocus
                    autoComplete="username"
                    required
                    id="username"
                    name="username"
                    defaultValue={userAccount.username}
                    onChange={(e) => onChange(e, "username", e.target.value)}
                    onBlur={() => onValidateField("username")}
                    onInput={(e) => onAutoFill(e, "username", e.target.value, userAccount.username)}
                    error={formErrors.username.hasError}
                    label={`Username ${ formErrors.username.hasError ? "(Invalid)" : "" }`}
                    helperText={ formErrors.username.hasError ? formErrors.username.errorMessage : ""}
                    fullWidth={true}
                    variant="outlined"
                  />

                </Element>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6}>
                    <Element name="element-password">
                      <TviTextFiled
                        autoComplete="new-password"
                        required
                        onChange={(e) => onChange(e, "password", e.target.value)}
                        onBlur={() => onValidateField("password")}
                        onInput={(e) => onAutoFill(e, "password", e.target.value, userAccount.password)}
                        error={formErrors.password.hasError}
                        label={`Password${ formErrors.password.hasError ? " (Invalid)" : "" }`}
                        type={showPass ? "text" : "password"}
                        fullWidth
                        id="password"
                        name="password"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={toggleShowPass}
                                edge="end"
                              >{showPass ? <Visibility /> : <VisibilityOff />}</IconButton>
                            </InputAdornment>
                          ),
                          autoComplete: 'new-password',
                          form: { autocomplete: 'off' },
                        }}
                      />
                    </Element>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} style={{ paddingBottom: "5px" }}>
                    <Element name="element-passwordConfirm">
                      <TviTextFiled
                        autoComplete="new-password"
                        required
                        onChange={(e) =>
                          onChange(e, "passwordConfirm", e.target.value)
                        }
                        onBlur={() => onValidateField("passwordConfirm")}
                        onInput={(e) => onAutoFill(e, "passwordConfirm", e.target.value, userAccount.passwordConfirm || '')}
                        error={formErrors.passwordConfirm.hasError}
                        label={`Confirm Password${ formErrors.passwordConfirm.hasError ? " (Invalid)" : "" }`}
                        helperText={formErrors.passwordConfirm.hasError ? formErrors.passwordConfirm.errorMessage : "" }
                        fullWidth
                        id="passConfirm"
                        name="passConfirm"
                        variant="outlined"
                        type={showPass ? "text" : "password"}
                      />
                    </Element>
                  </Grid>
                  <Grid item xs={12} style={{ paddingTop: "0px" }}>
                    <Typography variant="caption" style={{ color: formErrors.password.hasError ? Red[600] : "inherit" }}>
                      {formErrors.password.hasError ? "Error: " : ""}Minimum 8 characters, at least one uppercase letter, one lowercase letter &amp; one number.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "6px", paddingTop: "7px" }}>
                <Divider orientation="horizontal" />
              </Grid>

              <Grid item xs={12}>
                <Element name="element-broker">
                  <TviTextFiled
                    defaultValue={userAccount.broker}
                    onChange={(e) => onChange(e, "broker", e.target.value)}
                    onBlur={() => onValidateField("broker")}
                    error={formErrors.broker.hasError}
                    label={`Which broker's do you currently trade with?${ formErrors.broker.hasError ? " (Invalid)" : "" }`}
                    helperText={ formErrors.broker.hasError ? formErrors.broker.errorMessage : "" }
                    fullWidth={true}
                    id="user-details-broker"
                    name="user-details[broker]"
                    variant="outlined"
                  />
                </Element>
              </Grid>


              <Grid item xa={12}>
                <Element name="element-hearAboutUs">
                  <TviTextFiled
                    defaultValue={userAccount.hearAboutUs}
                    onChange={(e) => onChange(e, "hearAboutUs", e.target.value)}
                    onBlur={() => onValidateField("hearAboutUs")}
                    error={formErrors.hearAboutUs.hasError}
                    label={`Where did you hear about us?${ formErrors.hearAboutUs.hasError ? " (Invalid)" : "" }`}
                    helperText={ formErrors.hearAboutUs.hasError ? formErrors.hearAboutUs.errorMessage : "" }
                    fullWidth={true}
                    id="user-details-hear"
                    name="user-details[hear]"
                    variant="outlined"
                  />
                </Element>
              </Grid>

              <Grid item xs={12}>
                <Button
                  className={classes.nextBtn}
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={goToNextStep}
                  disabled={loading}
                >
                  {loading ? <Typography variant="h5"><CircularProgress size={20} />&nbsp;Please Wait...</Typography> : <Typography variant="h5">Next</Typography>}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Snackbar
          open={snackbar.open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.type} variant="filled"><Typography variant="body2">{snackbar.message}</Typography></Alert>
        </Snackbar>
      </Grid>
    );
  };
}

StepOne.propTypes = {};

const mapStateToProps = ({ payment, accountReducer, cartReducer }) => ({
  countries: payment.countries,
  formErrors: payment.formErrors,

  userDetails: payment.userDetails,
  loading: payment.loading,
  userAccount: accountReducer,
  cart: cartReducer.cart,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepOne));
